import { useState } from "react";
import { useLatest } from "react-use";

export default function useRefresh() {
    const [count, setCount] = useState(Math.random());
    const refresh = useLatest(setCount);
    const countRef = useLatest(count);
    return [count, () => refresh.current(countRef.current + 1)] as const;
}
